import { apiRequest } from './auth';

// API dla uprawnień
export const permissionsAPI = {
  // Pobierz listę wszystkich funkcji w systemie
  getFunctions: async () => {
    return await apiRequest('/admin/permissions/functions');
  },

  // Pobierz wszystkich użytkowników z ich uprawnieniami
  getUsersWithPermissions: async () => {
    return await apiRequest('/admin/permissions');
  },

  // Pobierz uprawnienia konkretnego użytkownika
  getUserPermissions: async (userId) => {
    return await apiRequest(`/admin/permissions/${userId}`);
  },

  // Zaktualizuj uprawnienia użytkownika
  updateUserPermissions: async (userId, permissions) => {
    console.log(`📤 [permissionsAPI.updateUserPermissions] Wysyłam uprawnienia dla użytkownika ${userId}:`, JSON.stringify(permissions, null, 2));
    const result = await apiRequest(`/admin/permissions/${userId}`, {
      method: 'PUT',
      body: JSON.stringify({ permissions }),
    });
    console.log(`📥 [permissionsAPI.updateUserPermissions] Otrzymano odpowiedź z serwera:`, JSON.stringify(result, null, 2));
    return result;
  }
};

export default permissionsAPI;
